import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { User } from '../models/user.model';
import { Userdeleted } from '../models/user-deleted.model';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
@Injectable({ providedIn: 'root' })
export class UserService {
 private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
    bank: environment.apiBankUrl, 
    pgl: environment.apiPglUrl,
    smt: environment.apiSmtUrl,
  };
  private getBaseUrl(): string {
    const userType = this.getUserType();
    return this.apiUrls[userType??'smt'];
  }
  private getUserType(): 'bank' | 'pgl' | 'smt' {
    const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
    if (!token) return 'smt';

    try {
      const decodedToken: any = jwtDecode(token);
      return decodedToken.type as 'bank' | 'pgl' | 'smt';
    } catch (error) {
      console.error('Error decoding token:', error);
      return 'smt';
    }
  }
  filtred: User[] = []
    constructor(private http: HttpClient) { }
    private users: User[] = [
    ];
    private usersdeleted: Userdeleted[] = [
    ];
    public users$ = new Subject<User[]>();
    public usersdeleted$ = new Subject<Userdeleted[]>();
 

    getAll() {
      const baseUrl = this.getBaseUrl();
      this.http.get(`${baseUrl}/users/`).subscribe(
        (users: User[]) => {
          if (users) {
            this.users = users;
            this.emitusers();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    getadminbanqueAll(banque:any) {
      const baseUrl = this.getBaseUrl();
      this.http.get(`${baseUrl}/users/adminbanque/filtredusers/${banque}`).subscribe(
        (users: User[]) => {
          if (users) {
            this.users = users;
            this.emitusers();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    getuserbanqueAll(banque:any) {
      const baseUrl = this.getBaseUrl();
      this.http.get(`${baseUrl}/users/userbanque/filtredusers/${banque}`).subscribe(
        (users: User[]) => {
          if (users) {
            this.users = users;
            this.emitusers();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    getAlldeleted() {
      const baseUrl = this.getBaseUrl();
      this.http.get(`${baseUrl}/users/deletedusers/all/`).subscribe(
        (usersdeleted: Userdeleted[]) => {
          if (usersdeleted) {
            this.usersdeleted = usersdeleted;
            
            this.emitusersdeleted();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
    emitusers() {
      this.users$.next(this.users);
    }
    emitusersdeleted() {
      this.usersdeleted$.next(this.usersdeleted);
    }
 
   // Add users//
addusers(user:User[]) {
return new Promise((resolve, reject) => {
  const baseUrl = this.getBaseUrl();
    this.http.post(`${baseUrl}/users/add_multiple_users/`,user).subscribe(
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
}     
comunicatewithusersms(user: User,message:any) {
return new Promise((resolve, reject) => {
  const baseUrl = this.getBaseUrl();
  this.http.post(`${baseUrl}/users/comunicatewithusersms/`,{user,message}).subscribe(
    (response) => {
      resolve(response);
    },
    (error) => {
      reject(error);
    }
  );
});
}
    getUserById(id: string) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}/users/${id}`).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    getUserdeletedById(id: string) {
      return new Promise((resolve, reject) => {      
        const baseUrl = this.getBaseUrl();
        this.http.get(`${baseUrl}/users/deleteduser/${id}`).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }     
    modifyUserwithimageById(id: string, user: User, images: File[]) {
      return new Promise((resolve, reject) => {
        const userData = new FormData();         
        userData.append('user', JSON.stringify(user));           
          images.forEach((element, pos) => 
          {  
            if(element.name=='cif')
{
  userData.append('image', element,'cif'+user.userId); 
}
else if(element.name=='di')
{
  userData.append('image', element,'di'+user.userId); 
}
else if(element.name=='affcnss')
{
  userData.append('image', element,'affcnss'+user.userId); 
}
else if(element.name=='ag')
{
  userData.append('image', element,'ag'+user.userId); 
}
          }
          )    
        console.log(userData)    
        console.log(user)
        const baseUrl = this.getBaseUrl();
        this.http.put(`${baseUrl}/users/${id}`, userData).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }  
    modifyUserById(id: string, user: User) {
      return new Promise((resolve, reject) => {
        const userData = new FormData();         
        userData.append('user', JSON.stringify(user)); 
        const baseUrl = this.getBaseUrl();           
        this.http.put(`${baseUrl}/users/${id}`, userData).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    completeUserById(id: string, user: User, images: File[]) {
      return new Promise((resolve, reject) => {
        const userData = new FormData();         
        userData.append('user', JSON.stringify(user));           
          images.forEach((element, pos) => 
          {  
            if(element.name=='cif')
{
  userData.append('image', element,'cif'+user.userId); 
}
else if(element.name=='di')
{
  userData.append('image', element,'di'+user.userId); 
}
else if(element.name=='affcnss')
{
  userData.append('image', element,'affcnss'+user.userId); 
}
else if(element.name=='ag')
{
  userData.append('image', element,'ag'+user.userId); 
}
          }
          )    
        console.log(userData)    
        console.log(user)
        const baseUrl = this.getBaseUrl();           
        this.http.put(`${baseUrl}/users/${id}`, userData).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }  
    desactivateUser(id: string, user: User) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();           
        this.http.put(`${baseUrl}/users/desactivate/${id}`, user).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    liberateUser(id: string, user: User) {
      return new Promise((resolve, reject) => { 
        const baseUrl = this.getBaseUrl();           
        this.http.put(`${baseUrl}/users/nostandby/${id}`, user).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    deletetemporarUser(id: string) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();           
        this.http.delete(`${baseUrl}/users/temporardelete/${id}`).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    restaureUser(id: string) {
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();           
        this.http.delete(`${baseUrl}/users/restaure/${id}`).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    /*activateUser(id: string, user: User) {
      return new Promise((resolve, reject) => {
        
          
        
        this.http.put(API_URL_cloud+'activate/'+id, user).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    standbyUser(id: string, user: User) {
      return new Promise((resolve, reject) => {
        this.http.put(API_URL_cloud+'standby/'+id, user).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    connectUser(id: string, user: User) {
      return new Promise((resolve, reject) => {
        
          
        
        this.http.put(API_URL_cloud+'connect/'+id, user).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }
    disconnectUser(id: string, user: User) {
      return new Promise((resolve, reject) => {
        
          
        
        this.http.put(API_URL_cloud+'disconnect/'+id, user).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }*/
  deleteUserById(id: string) {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();           
      this.http.delete(`${baseUrl}/users/${id}`).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }  
  verifyEmail(token: string) 
  {
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();           
      this.http.post(`${baseUrl}/users/verify-email/`, { token }).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  forgotPassword(email: string) 
{
  return new Promise((resolve, reject) => {
    const baseUrl = this.getBaseUrl();           
    this.http.post(`${baseUrl}/users/forgot-password/`, { email }).subscribe(
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

validateResetToken(token: string) 
{
  return new Promise((resolve, reject) => {
    const baseUrl = this.getBaseUrl();           

    this.http.post(`${baseUrl}/users/validate-reset-token/`, { token }).subscribe(
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
}

resetPassword(token: string, password: string, confirmPassword: string) 

{
  return new Promise((resolve, reject) => {
    const baseUrl = this.getBaseUrl();           

    this.http.post(`${baseUrl}/users/reset-password/`, { token, password, confirmPassword }).subscribe(
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
}
getuserbyfirstname(firstname: string) 
{
  const baseUrl = this.getBaseUrl();           
    this.http.post(`${baseUrl}/users/filteruserfirstname/`, { firstname }).subscribe(
      (users: User[]) => {
        if (users) {
          this.users = users;
          this.emitusers();
        }
      },
      (error) => {
        console.log(error);
      }
    );
  
}
getuserbylastname(lastname: string) 
{
  const baseUrl = this.getBaseUrl();           
    this.http.post(`${baseUrl}/users/filteruserlastname/`, { lastname }).subscribe(
      (users: User[]) => {
        if (users) {
          this.users = users;
          this.emitusers();
        }
      },
      (error) => {
        console.log(error);
      }
    );
  
}
getuserbyemail(email: string) 
{
  const baseUrl = this.getBaseUrl();           
    this.http.post(`${baseUrl}/users/filteruseremail/`, { email }).subscribe(
      (users: User[]) => {
        if (users) {
          this.users = users;
          this.emitusers();
        }
      },
      (error) => {
        console.log(error);
      }
    );
  
}
getuserbycard(card: string) 
{
    return new Promise((resolve, reject) => {
      const baseUrl = this.getBaseUrl();           
      this.http.post(`${baseUrl}/users/filterusercardnumber/`, { card }).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
}
getuserbydata(datas:any) 
{
  console.log(datas)
  return new Promise((resolve, reject) => {
    const baseUrl = this.getBaseUrl();           
    this.http.post(`${baseUrl}/users/filteruserchoice/`, { datas }).subscribe(
      (response) => {
        resolve(response);
      },
      (error) => {
        reject(error);
      }
    );
  });
}
  }